"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDrillToCustomUrlParams = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var effects_1 = require("redux-saga/effects");
var insightDrillDefinitionUtils_1 = require("../widgets/validation/insightDrillDefinitionUtils");
var ui_1 = require("../../store/ui");
var drillTargetsSelectors_1 = require("../../store/drillTargets/drillTargetsSelectors");
var catalogSelectors_1 = require("../../store/catalog/catalogSelectors");
var isDisplayFormRelevantToDrill_1 = require("./isDisplayFormRelevantToDrill");
function validateDrillToCustomUrlParams(widgets) {
    var possibleInvalidDrills, invalidDrills;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.all(widgets.map(function (widget) { return effects_1.call(validateWidgetDrillToCustomUrlParams, widget); }))];
            case 1:
                possibleInvalidDrills = _a.sent();
                invalidDrills = possibleInvalidDrills.filter(function (_a) {
                    var invalidDrills = _a.invalidDrills;
                    return invalidDrills.length > 0;
                });
                if (!(invalidDrills.length === 0)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(ui_1.uiActions.resetInvalidCustomUrlDrillParameterWidget(widgets))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.put(ui_1.uiActions.setInvalidCustomUrlDrillParameterWidgets(invalidDrills))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
exports.validateDrillToCustomUrlParams = validateDrillToCustomUrlParams;
function validateWidgetDrillToCustomUrlParams(widget) {
    var selectDrillTargetsByWidgetRefSelector, drillTargets, displayForms;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                selectDrillTargetsByWidgetRefSelector = drillTargetsSelectors_1.selectDrillTargetsByWidgetRef(sdk_model_1.widgetRef(widget));
                return [4 /*yield*/, effects_1.select(selectDrillTargetsByWidgetRefSelector)];
            case 1:
                drillTargets = _a.sent();
                if (!(drillTargets === null || drillTargets === void 0 ? void 0 : drillTargets.availableDrillTargets)) {
                    // skip this part of the validation in case the drill targets are not available yet
                    return [2 /*return*/, {
                            widget: widget,
                            invalidDrills: [],
                        }];
                }
                return [4 /*yield*/, effects_1.select(catalogSelectors_1.selectAllCatalogDisplayFormsMap)];
            case 2:
                displayForms = _a.sent();
                return [2 /*return*/, widget.drills.filter(sdk_model_1.isDrillToCustomUrl).reduce(function (acc, drillDefinition) {
                        var ids = insightDrillDefinitionUtils_1.extractDisplayFormIdentifiers([drillDefinition]);
                        var hasInvalidParam = ids.some(function (identifier) {
                            var displayForm = displayForms.get(identifier);
                            if (!displayForm) {
                                // the drill as a whole is invalid, no reason to validate the parameters
                                return false;
                            }
                            return !isDisplayFormRelevantToDrill_1.isDisplayFormRelevantToDrill(drillDefinition, drillTargets.availableDrillTargets, displayForm);
                        });
                        if (hasInvalidParam) {
                            acc.invalidDrills.push(drillDefinition);
                        }
                        return acc;
                    }, { widget: widget, invalidDrills: [] })];
        }
    });
}
//# sourceMappingURL=validateDrillToCustomUrlParams.js.map